import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import 'moment/locale/ca';

import locale_ca from 'antd/es/date-picker/locale/ca_ES';
import locale_en from 'antd/es/date-picker/locale/en_GB';
import locale_es from 'antd/es/date-picker/locale/es_ES';

import { translate } from 'react-multi-lang';
import { Table, Row, Col, Pagination, DatePicker, Input, Space, Button, Modal, Select, Form, Tooltip, Popconfirm, message } from 'antd';
import { SearchOutlined, GoldOutlined, CheckOutlined, CloseOutlined, EditOutlined, DeleteOutlined, AlertFilled, ClearOutlined, UploadOutlined} from '@ant-design/icons';
import { AllHtmlEntities } from 'html-entities';

import ContainerPagina from '../../../components/ContainerPagina';
import TitolPagina from '../../../components/TitolPagina';
import TriaCursEscolar from '../../../components/TriaCursEscolar';
import RebutsForm from '../../../components/Formularis/perfils/admin/Rebuts';
import EntregatACompteImportar from '../../../components/Formularis/perfils/admin/EntregatACompteImportar';

import { Api, InitDades } from '../../../helpers';
import { PerfilUsuariContext } from "../../../context/perfil-usuari";

const { Column } = Table;
const entities = new AllHtmlEntities();
const dateFormat = 'DD/MM/YYYY HH:mm';
const dateRangeFormat = 'DD/MM/YYYY';

function EntregatACompte(props){
  moment.locale('es');

  const [perfilUsuari] = useContext(PerfilUsuariContext);
  const [dades, setDades] = useState([]);
  const [id_rebut, setId_rebut] = useState(0)
  const [selectPressupostos, setSelectPressupostos] = useState([]);
  const [loadingPressupost, setLoadingPressupost] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [ids_pressupost, setIds_pressupost] = useState([]);
  const [rebutTriat, setRebutTriat] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [refrescar, setRefrescar] = useState(0);
  const [cursEscolarTriat, setCursEscolarTriat] = useState(perfilUsuari.curs_escolar_actual.id);
  const [modalImportarVisible, setModalImportarVisible] = useState(false);

  //CERCA
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [searchInput, setSearchInput] = useState([]);
  //FI CERCA
  //filtres i ordenacio
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

    const tableHandleChange = (pagination, filters, sorter) => {
      setFilteredInfo(filters);
      setSortedInfo(sorter);
    }
    const clearAllFilters = () => {
      setFilteredInfo({});
      setSortedInfo({});
    }
  //FI filtres i ordenacio


  useEffect(() => {
    buscarDadesPressupost();
  },[cursEscolarTriat]);

  useEffect(() => {
    buscarDades();
  },[ids_pressupost])

  const buscarDadesPressupost = async () =>{
    setLoadingPressupost(true);
    setIds_pressupost([]);
    const c = await Api.get('/pressupost/'+cursEscolarTriat);
    if(c.result.success===1){

      const facturats = c.data.pressuposts.filter((element, index, arr) => element.facturat === true);
      //console.log('des: ', facturats)
      let pressus = [];
      let ultim_pressu = 0;
      const select = facturats.map((item)=>{
        pressus[item.id] = item.descripcio;
        if(item.id > ultim_pressu) {
          ultim_pressu = item.id
        }
        return(
          <Select.Option key={item.id} value={item.id}>
            <span>{entities.decode(item.descripcio)}</span>
          </Select.Option>
        );
      });
      setSelectPressupostos(select);
      setIds_pressupost([ultim_pressu]);
      setLoadingPressupost(false);
      //setPressupostosDesc(pressus);
    }
  }

  const buscarDades = async () => {
    if(ids_pressupost.length > 0){
      setIsLoading(true)
      const tmp = await Api.get(`/rebuts/entregat/compte/pressupost/${ids_pressupost}`);
      if(tmp.result.success===1){
        setDades(tmp.data.rebuts_entregat);
      }
      setIsLoading(false)
    }
  }

  const triaPressupostChange = (value) => {
    setIds_pressupost(value);
  }

  const obrirModal = async item =>{


    const rebutTrobat = await Api.get(`/rebut/header/${item.id_rebut}`);
    if(rebutTrobat.result.success===1){
      let rebut  = rebutTrobat.data.rebut;
      const liniesTrobades = await Api.get(`/rebut/linies/${item.id_rebut}`);
      if(liniesTrobades.result.success===1){
        rebut.linies = liniesTrobades.data.linies;
        rebut.fcrea = moment(item.fcrea).tz('Europe/Madrid');
        setRebutTriat(rebut);
        setModalVisible(true);
      }
    }
  }

  const tancarModal = async e =>{
    setModalVisible(false);
  }

  const tancarModalImportar = () => {
    setModalImportarVisible(false);
    buscarDades();
  }

  const estatModificat = () =>{
    setRefrescar(refrescar+1);
  }

  const tradueixTipusPagament = (value) =>{
    switch (value) {
      case 'BANC':
        return props.t('families.pagament_banc');
        break;
      case 'TRANSFERENCIA':
        return props.t('families.pagament_transferencia');
        break;
      case 'EFECTIU':
        return props.t('families.pagament_efectiu');
        break;
      case 'TARGETA':
        return props.t('families.pagament_targeta');
        break;
      case 'XEC_GUARDERIA':
        return props.t('families.pagament_xec_guarderia');
        break;
      default:
        return '--';

    }
  }


  //CERCA
    const getColumnSearchProps = (dataIndex, nom) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => {
              let search = searchInput;
              search[dataIndex] = node;
              setSearchInput(search);
            }}
            placeholder={`${props.t('generic.cercar')} ${nom}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            autoFocus="focus"
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              {props.t('generic.cercar')}
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
        record[dataIndex] ? arreglarTxt4Search(entities.decode(record[dataIndex].toString())).includes(arreglarTxt4Search(value)) : '',
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => searchInput[dataIndex].select(),100);
        }
      },
     render: text => (entities.decode(text)),
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
    };

    const handleReset = clearFilters => {
      clearFilters();
      setSearchText('');
    };

    const arreglarTxt4Search = text =>{
        // Poso en minuscules, normalitzo caracters treure accents i ñ , elimina els caracters diacrítics raros d'un text (ES6)
        //return text.trim().split(' ')[0].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"");
        return text.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"");
    }
  //FI CERCA


  const filtreTipusPagament =[
    {text: <span>{props.t('families.pagament_banc')}</span>, value: 'BANC'},
    {text: <span>{props.t('families.pagament_transferencia')}</span>, value: 'TRANSFERENCIA'},
    {text: <span>{props.t('families.pagament_efectiu')}</span>, value: 'EFECTIU'},
    {text: <span>{props.t('families.pagament_targeta')}</span>, value: 'TARGETA'},
    {text: <span>{props.t('families.pagament_xec_guarderia')}</span>, value: 'XEC_GUARDERIA'},

  ];

  const columns = [
    {
      title:"Id",
      key:"id",
      dataIndex:'id',
      sorter: (a, b) =>  a.id - b.id,
      sortOrder: sortedInfo.columnKey === 'id' && sortedInfo.order,
      render: (text,record) => (<span>{record.id}</span>)
    },
    {
      title:"Id_rebut",
      key:"id_rebut",
      render: (text,record) => (<span>{record.id_rebut}</span>)
    },
    {
      title: props.t('generic.alumne'),
      key: "alumne",
      dataIndex: "alumne",
      render: (text,record) => (entities.decode(record.alumne)),
      sorter: (a, b) => { return entities.decode(a.alumne).localeCompare(entities.decode(b.alumne))},
      sortOrder: sortedInfo.columnKey === 'alumne' && sortedInfo.order,
      ...getColumnSearchProps('alumne',props.t('generic.alumne')),
      filteredValue: filteredInfo.alumne || null,
    },
    {
      title: props.t('generic.concepte'),
      key: "concepte",
      dataIndex: "concepte",
      render: (text,record) => <span>{entities.decode(record.concepte)}</span>
    },
    {
      title: props.t('quotes.import'),
      width: '100px',
      key: "import",
      dataIndex: "import",
      sorter: (a, b) =>  a.import - b.import,
      sortOrder: sortedInfo.columnKey === 'import' && sortedInfo.order,
    },
    {
      title: props.t('families.tipus_pagament'),
      key: "tipus_pagament",
      width: "175px",
      dataIndex: "tipus_pagament",
      filters: filtreTipusPagament,
      filteredValue: filteredInfo.tipus_pagament || null,
      onFilter: (value, record) => record.tipus_pagament === value,
      render: (text,record) => (tradueixTipusPagament(record.tipus_pagament)),
      sorter: (a, b) => { return entities.decode(tradueixTipusPagament(a.tipus_pagament)).localeCompare(entities.decode(tradueixTipusPagament(b.tipus_pagament)))},
      sortOrder: sortedInfo.columnKey === 'tipus_pagament' && sortedInfo.order,
    },
    {
      title: props.t('generic.data'),
      key: "data_pagament",
      dataIndex: "data_pagament",
      width: "175px",
      sorter: (a, b) => moment(a.data_pagament).diff(moment(b.data_pagament)),
      sortOrder: sortedInfo.columnKey === 'data_pagament' && sortedInfo.order,
      render: (text,record) =>(
          record.data_pagament ? moment(record.data_pagament).tz('Europe/Madrid').format("DD/MM/YYYY") : ''
      )
    },{
      title: (
        <Tooltip placement="top" title="Clear filters">
          <Button icon={<ClearOutlined />} onClick={(e) => clearAllFilters()} ghost="true" className="BotoTaula"/>
        </Tooltip>
      ),
      key: "actions",
      align: "right",
      width: "75px",
      render: (text,record) => (
        <Row type="flex" justify="end" id={"actions_"+record.id}>
          <Col span={24 }>
            <Tooltip placement="top" title={props.t('generic.modify')}>
              <Button icon={<EditOutlined />} onClick={(e) => obrirModal(record)} ghost="true" className="BotoTaula"/>
            </Tooltip>
          </Col>

        </Row>
    )
    }
  ];

  return(
    <ContainerPagina>
      <TitolPagina txt={props.t('rebuts.entregat_compte')}/>
      <div style={{marginTop:'1rem', marginLeft:'3rem', marginRight: '1rem'}}>
        <Row align="middle" justify="space-between" gutter={5} style={{marginBottom: '1rem'}}>
          <Col>
            <TriaCursEscolar onChange={(c) => setCursEscolarTriat(c)}/>
            { !selectPressupostos ? null :
              <Select
                mode="multiple"
                allowClear
                loading={loadingPressupost}
                style={{ minWidth: '300px' }}
                placeholder={props.t('generic.tria')}
                onChange={triaPressupostChange}
                defaultValue={""}
                value={ids_pressupost}
              >
                  {selectPressupostos}
              </Select>
              }
          </Col>
          <Col>
            <Button
              icon={<UploadOutlined />}
              type="primary"
              onClick={() => setModalImportarVisible(true)}
            >
              {props.t('alumnes_classes.importar_excel') || 'Importar Excel'}
            </Button>
          </Col>
        </Row>
        {!dades.length ? null :
          <Table
            loading={isLoading}
            key="entregat_compte_taula"
            dataSource={dades}
            columns={columns}
            pagination={false}
            size={'small'}
            locale={{filterConfirm: 'OK', filterReset: 'Reset', emptyText: 'No Data'}}
            onChange={tableHandleChange}
            onRow={(record, rowIndex) => {
              return {
                onClick: event => {},
                onDoubleClick: (e) => obrirModal(record),
                onContextMenu: (e) => {e.preventDefault(); obrirModal(record);},
              };
            }}
            />
          }
      </div>
      <Modal
          key="rollcall"
          title={`${rebutTriat.id === 0 ? props.t('generic.add') : props.t('generic.modify')} ${props.t('menu.Rebuts')} ${rebutTriat.id === 0 ? '' : ' - ID: '+rebutTriat.id}`}
          visible={modalVisible}
          footer={null}
          onCancel={tancarModal}
          width={1200}
          style={{top:20}}
          destroyOnClose={true}
          forceRender={true}
        >

        <RebutsForm item={rebutTriat} callback={tancarModal} callback_refrescar={estatModificat}/>
      </Modal>
      <Modal
          title={`${props.t('rebuts.importar_entregat') || 'Importar'} ${props.t('rebuts.entregat_compte')}`}
          visible={modalImportarVisible}
          footer={null}
          onCancel={tancarModalImportar}
          width={1200}
          style={{top:20}}
          destroyOnClose={true}
        >
          <EntregatACompteImportar callback={tancarModalImportar} />
      </Modal>
      </ContainerPagina>
    );
}

export default translate(EntregatACompte);
